import {Box, Skeleton} from '@mui/material';

export const KanbanColumnSkeleton = () => {
    return (
        <Box display="flex" width="100%" height="100%">
            <Skeleton variant="rounded" width="20%" height={'44px'} />
            <Skeleton style={{marginLeft: '5px'}} variant="rounded" width="20%" height={'44px'} />
            <Skeleton style={{marginLeft: '5px'}} variant="rounded" width="20%" height={'44px'} />
            <Skeleton style={{marginLeft: '5px'}} variant="rounded" width="20%" height={'44px'} />
            <Skeleton style={{marginLeft: '5px'}} variant="rounded" width="20%" height={'44px'} />
        </Box>
    );
};

export default KanbanColumnSkeleton;
